import React, { useState, useEffect } from 'react'
import "./ToDo.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import axios from 'axios';
import AllGroups from './AllGroups';
import { ipAddress } from '../../ipAddress';

interface Props {

}
interface Group {
  name: string,
  id: number,
  isDone: boolean,
  date: string,
}


const ToDo: React.FC<Props> = () => {

  const [addGroup, setAddGroup] = useState<boolean>(false);
  const [nameGroup, setNameGroup] = useState<string>('');
  const [allGroups, setAllGroups] = useState<Group[]>([])

const updateGroups = () => {
  axios.post(ipAddress + '/getGroups')
  .then((response) => {
    setAllGroups(response.data);
  })
}

useEffect(() => {
  updateGroups();

 
}, [allGroups])


  const confirmGroup = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/addGroupTodo', {
      name: nameGroup,
      id: Math.random(),
      isDone: 0,
      date: '',
    }).then(

    )
      .catch(err => {
        console.log(err);
      })

    setAddGroup(false);
    setNameGroup('');

  }

  const cancel = () => {
    setAddGroup(false);
    setNameGroup('');
  }

 



  return (
    <div className='toDo'>
      <div className='title'>
        <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>To do</span>
      </div>
      <div className='toDo2'>
        <Link to='/ToDo'>Zaplanowane</Link>
        <Link to='/ToDo/Zakonczone'>Zakończone</Link>
      </div>

      <Outlet />
     

      {addGroup ?
        (
          <form className='addGroup' onSubmit={(e) => { confirmGroup(e) }}>
            <button className='icon' id='close' onClick={() => cancel()} >X</button>
            <p>Dodaj nową grupe</p>
            <div className='groupName'>
              <label htmlFor="thing">Nazwa: </label>
              <input type="text" placeholder='Wpisz nazwę grupy' required
                value={nameGroup}
                onChange={(e) => (setNameGroup(e.target.value))}
              ></input>
            </div>


            <div className='newLine'>
              <button type='submit' id='submit' >OK</button>

            </div>
          </form>
        ) :
        (
          <div></div>
        )

      }

      <div>
        {allGroups.map((group) => (
          <AllGroups group={group} key={group.id}/>
        ))}
      </div>
       <footer>
        <button type='button' onClick={() => setAddGroup(true)} id='circle'><p>+</p></button>
      </footer>

    </div>
  )
}

export default ToDo;